<script>
import { url, params } from '@sveltech/routify';
import { getLabel, getCategoryName } from '../utils/constant.js';

export let image_url;
export let regions;
export let analyze;
export let current_region;

function get_element_id(region) {
  let category = region.category1 ? region.category1.label : region.category.code;
  var elem_id = "detection_" + category + "_" + region.id;
  elem_id = elem_id.replace(/,/gi, "_");
  return elem_id;
}

function getCurrentAttributes(currentRegion, analyzeResult) {
  if (currentRegion === undefined) {
    return [];
  }
  let attribute = [];
  [['gender', 'gender'],
    ['category2', 'category'],
    ['category3', 'sub_category'],
  ].forEach(item => {
    if (currentRegion[item[0]] !== undefined) {
      attribute.push({
        en: getLabel(currentRegion[item[0]]),
        type: [item[1]],
      });
    }
  });
  if (currentRegion.virtual_category !== undefined) {
    attribute.push({
      en: currentRegion.virtual_category.label.replace('vc.', '').replace('_', ' '),
      type: 'custom_category',
    });
  }
  let currentAnalyze = analyzeResult.find(a => a.id === currentRegion.id);
  if (currentAnalyze) {
    attribute = [ ...attribute, ...currentAnalyze.attributes
      .filter(a => a.type !== 'gender')  // filter gender for v1 api
      .filter(a => a.en !== 'unknown')  // filter unknown category for v1 api
    ];
  }
  return attribute;
}
</script>

<div id="query-image">
  <div class="cropper-view">
      {#if image_url}
      <img src={image_url} class="query-image" alt="">
      {/if}
      {#if current_region}
      <div id="crop-area" style="
        top: {current_region.ry1 * 100}%;
        left: {current_region.rx1 * 100}%;
        right: {(1 - current_region.rx2) * 100}%;
        bottom: {(1 - current_region.ry2) * 100}%;
      ">
        <div class="dimmer-top"></div>
        <div class="dimmer-right"></div>
        <div class="dimmer-bottom"></div>
        <div class="dimmer-left"></div>
      </div>
      {/if}
  </div>
  <div class="results" id="results">
    {#if regions}
    <div id="results_detection">
      <div class="label">ITEMS</div>
      <div id="detection_list">
        {#each regions as region}
        <div id={get_element_id(region)} class="item" class:select={current_region && region.id === current_region.id}>
          <a href={$url(`/view/?${$params.image_url ? `image_url=${encodeURIComponent($params.image_url)}&` : ''}type=${$params.type}&region=${region.id}`)}>
            {getCategoryName(region)}
            <b>{parseInt(100 * (region.category1 || region).score)}%</b>
          </a>
        </div>
        {/each}
      </div>
    </div>
    {/if}

    <div id="attribute_list">
      <div class="label">ATTRIBUTES</div>
      <ul>
        {#each getCurrentAttributes(current_region, analyze) as attr}
        <li>
          <div class="value">#{attr.en}</div>
          <div class="type">{attr.type}</div>
        </li>
        {/each}
      </ul>
    </div>
  </div>
</div>
